export const MainContent = ({ children }) => {
  return <main id="main-content">{children}</main>;
};
